import { takeLatest, call, put } from 'redux-saga/effects'
import {
    addPolicyAPI, assignPolicyAPI, policyDetailAPI, policyListAPI,
    policyMarkCompleteAPI
} from '../api-requests/policy';
import {
    addPolicyRequestError, addPolicyRequestSuccess, assignPolicyRequestError,
    assignPolicyRequestSuccess, policyDetailRequestError, policyDetailRequestSuccess,
    policyListRequestError, policyListRequestSuccess, policyMarkCompleteRequestError,
    policyMarkCompleteRequestSuccess
} from './policy.action';
import { PolicyActionTypes } from './policy.types'
import { displayConsoleLog } from '../../utils/Utils'
import { decryptResponseData } from '../../utils/DataDecryptionUtils';

function* handlePolicyMarkCompleteRequest({ payload }) {
    try {
        const response = yield call(policyMarkCompleteAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(policyMarkCompleteRequestSuccess(decryptedData))
            } else {
                yield put(policyMarkCompleteRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(policyMarkCompleteRequestError(error.response.data))
    }
}

export function* policyMarkCompleteReq() {
    yield takeLatest(PolicyActionTypes.POLICY_MARK_COMPLETE_REQUEST, handlePolicyMarkCompleteRequest)
}

function* handlePolicyList({ payload }) {
    try {
        const response = yield call(policyListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(policyListRequestSuccess(decryptedData))
            } else {
                yield put(policyListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(policyListRequestError(error.response.data))
    }
}

export function* policyListReq() {
    yield takeLatest(PolicyActionTypes.POLICY_LIST_REQUEST, handlePolicyList)
}

function* handlePolicyDetail({ payload }) {
    try {
        const response = yield call(policyDetailAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(policyDetailRequestSuccess(decryptedData))
            } else {
                yield put(policyDetailRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(policyDetailRequestError(error.response.data))
    }
}

export function* policyDetailReq() {
    yield takeLatest(PolicyActionTypes.POLICY_DETAIL_REQUEST, handlePolicyDetail)
}

function* handleAssignPolicy({ payload }) {
    try {
        const response = yield call(assignPolicyAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(assignPolicyRequestSuccess(decryptedData))
            } else {
                yield put(assignPolicyRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(assignPolicyRequestError(error.response.data))
    }
}

export function* assignPolicyReq() {
    yield takeLatest(PolicyActionTypes.ASSIGN_POLICY_REQUEST, handleAssignPolicy)
}

function* handleAddPolicy({ payload }) {
    try {
        const response = yield call(addPolicyAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(addPolicyRequestSuccess(decryptedData))
            } else {
                yield put(addPolicyRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(addPolicyRequestError(error.response.data))
    }
}

export function* addPolicyReq() {
    yield takeLatest(PolicyActionTypes.ADD_POLICY_REQUEST, handleAddPolicy)
}